// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// ✅ Correct Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBMecYu9QBXIbucQ6-PxSBMAoDiTkRbWxQ",
  authDomain: "portfolio-builder-d99da.firebaseapp.com",
  projectId: "portfolio-builder-d99da",
  storageBucket: "portfolio-builder-d99da.appspot.com", // ← fixed this line!
  messagingSenderId: "556547495982",
  appId: "1:556547495982:web:4b02b85fbfe0a4f0b827bf"
};

// ✅ Initialize Firebase
const app = initializeApp(firebaseConfig);

// ✅ Export services to use in your app
export const auth = getAuth(app);
export const db = getFirestore(app);
